var render = function render(_c,_vm){return _c('div',{staticClass:"card-single-select-option__wrapper"},[(_vm.props.value)?_c('div',{staticClass:"card-single-select-option",class:'background-color--' + _vm.props.value.color},[_vm._v("\n    "+_vm._s(_vm.props.value.value)+"\n  ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }